import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AlbaniaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<mask
				id='mask0_2332_14191'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14191)'>
				<rect
					width='20'
					height='14'
					fill='#EE343C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.95398 3.17477C8.73066 2.95592 8.38518 2.92185 8.12342 3.09287C7.69095 3.37541 7.73076 4.02136 8.19465 4.24867L8.7259 4.50898C8.92292 4.60552 9.04781 4.80579 9.04781 5.02519C9.04781 5.34268 8.79043 5.60005 8.47295 5.60005H8.24998C8.14829 5.60005 8.04795 5.57679 7.95664 5.53204L6.58978 4.86229C6.35058 4.74508 6.06347 4.79136 5.87322 4.97781C5.56336 5.28148 5.647 5.80032 6.0366 5.99123L6.50433 6.22041C6.78608 6.35847 6.81026 6.7508 6.54759 6.92241C6.2437 7.12096 6.33483 7.58831 6.69106 7.65813L7.10348 7.73896C7.4827 7.81329 7.59232 8.30316 7.28094 8.53203L6.92883 8.79083C6.69499 8.96271 6.81656 9.33338 7.10677 9.33338C7.13087 9.33338 7.15487 9.33049 7.17827 9.32475L8.09471 9.10022C8.43002 9.01807 8.69005 9.39262 8.49587 9.67806C8.32572 9.92818 8.50487 10.2667 8.80738 10.2667H9.23435C9.40753 10.2667 9.5615 10.377 9.61727 10.5409C9.74163 10.9066 10.2587 10.9066 10.3831 10.5409C10.4389 10.377 10.5928 10.2667 10.766 10.2667H11.193C11.4955 10.2667 11.6747 9.92818 11.5045 9.67806C11.3103 9.39262 11.5704 9.01807 11.9057 9.10022L12.8221 9.32475C12.8455 9.33049 12.8695 9.33338 12.8936 9.33338C13.1838 9.33338 13.3054 8.96271 13.0715 8.79083L12.7194 8.53203C12.4081 8.30316 12.5177 7.81329 12.8969 7.73896L13.3093 7.65813C13.6655 7.58831 13.7567 7.12096 13.4528 6.92241C13.1901 6.7508 13.2143 6.35847 13.496 6.22041L13.9638 5.99123C14.3534 5.80032 14.437 5.28148 14.1271 4.97781C13.9369 4.79136 13.6498 4.74508 13.4106 4.86229L12.0437 5.53204C11.9524 5.57679 11.8521 5.60005 11.7504 5.60005H11.5274C11.2099 5.60005 10.9526 5.34268 10.9526 5.02519C10.9526 4.80579 11.0773 4.60561 11.2743 4.50906C11.4417 4.42705 11.625 4.3372 11.8058 4.24865C12.2696 4.02135 12.3094 3.37541 11.8769 3.09287C11.6152 2.92185 11.2697 2.95592 11.0464 3.17477L10.4668 3.74276C10.2076 3.9968 9.79278 3.9968 9.53357 3.74276L8.95398 3.17477Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default AlbaniaFlagIcon;
